<template>
  <section>
    <div class="container">
      <div class="page-container">
        <div class="content-wrap">
          <h1 class="display-3 section-title color">Contact me</h1>
          <div class="main-container">
            <p class="smspecial">
              “Alone we can do so little; together we can do so much.” — Helen
              Keller
            </p>
            <!-- <p>
              If you have a request or question, don’t hesitate to use the form.
            </p> -->
            <div class="form-container">
              <form @submit.prevent="submitForm">
                <div class="row g-0 gy-lg-0 gy-3">
                  <div class="col-lg-6 h-100 pe-lg-2">
                    <input
                      type="text"
                      name="name"
                      v-model="name"
                      required
                      placeholder="Name"
                      maxlength="50"
                      class="color"
                    />
                    <input
                      type="email"
                      name="email"
                      v-model="email"
                      required
                      placeholder="Email"
                      maxlength="50"
                      class="color"
                    />
                    <input
                      type="subject"
                      name="subject"
                      v-model="subject"
                      required
                      placeholder="subject"
                      maxlength="75"
                      class="color"
                    />
                  </div>
                  <div class="col-lg-6 ps-lg-2 pb-0">
                    <textarea
                      name="message"
                      v-model="message"
                      required
                      placeholder="Message"
                      class="color"
                    ></textarea>
                  </div>
                </div>
                <input type="submit" name="submit" class="color" />
              </form>
              <div class="sentMessage" v-if="sentMessage" v-motion-slide-right>
                <p>
                  Thank you for your interest. I will reply as soon as possible.
                  <br />
                  <strong><em>Live Life!</em></strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div>
            <a href="https://linkedin.com/in/geo-sudo/" target="_blank"
              ><svg
                class="color"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path
                  d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                /></svg
            ></a>
            <a href="https://blog.geosalib.com" target="_blank"
              ><svg
                class="color"
                mlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  d="M0 0 C168.96 0 337.92 0 512 0 C512.1546875 80.5303125 512.1546875 80.5303125 512.3125 162.6875 C512.35802002 179.64084717 512.40354004 196.59419434 512.45043945 214.0612793 C512.47302246 234.75939941 512.47302246 234.75939941 512.47721863 244.44831848 C512.48187789 251.21700232 512.50020405 257.98547938 512.52787781 264.75410461 C512.55976728 272.56542301 512.57416513 280.37654336 512.56722475 288.18792729 C512.5642203 292.1814896 512.56889107 296.1746096 512.59607565 300.16809022 C512.62055642 303.78650451 512.62152266 307.4041672 512.60450554 311.02261734 C512.60141263 312.93587428 512.62282779 314.84912371 512.64540386 316.76224995 C512.52877423 330.4155573 507.69943957 340.86330831 498.41796875 350.671875 C490.41540477 358.22660693 480.48777284 362.15571028 469.64124393 362.13701439 C468.89426214 362.13966622 468.14728035 362.14231804 467.37766275 362.14505023 C464.86057299 362.15274388 462.34353201 362.15330243 459.82643127 362.15390015 C458.00908134 362.15791474 456.1917323 362.16235295 454.37438434 362.1671797 C449.36902474 362.17915165 444.36367478 362.18479511 439.35830367 362.18936086 C433.96406714 362.19531467 428.56984215 362.20692514 423.1756134 362.21765137 C410.14188303 362.24218152 397.10814884 362.25680398 384.07440248 362.26971143 C380.39319079 362.2734231 376.71197947 362.27739636 373.03076816 362.2814641 C350.17254973 362.30670173 327.31433071 362.3287556 304.45610142 362.34119225 C299.16059428 362.34412196 293.86508717 362.34708362 288.56958008 362.35009766 C286.59531055 362.35121673 286.59531055 362.35121673 284.58115678 362.35235842 C263.26354388 362.36500991 241.94603134 362.39822974 220.62845398 362.43989949 C198.74331385 362.482328 176.85821643 362.5058884 154.97303528 362.51111281 C142.68490909 362.51452601 130.39691329 362.52627053 118.10882759 362.55921555 C107.64265002 362.58722982 97.17662955 362.59820929 86.7104174 362.58702008 C81.37207609 362.58183692 76.0340637 362.58469831 70.69577026 362.60948563 C65.80316342 362.63201339 60.91112111 362.63121067 56.01850414 362.61228175 C54.25392794 362.6094867 52.48931316 362.61505262 50.72479887 362.63009469 C34.9463854 362.75631543 23.07073581 359.52955141 11.328125 348.41796875 C4.44312119 341.12483327 -0.12688643 331.4273468 -0.12304783 321.4009285 C-0.1250387 320.25353447 -0.12702957 319.10614044 -0.12908077 317.9239769 C-0.12616811 316.66364765 -0.12325544 315.40331841 -0.12025452 314.10479736 C-0.12069194 312.75580322 -0.12156885 311.40680916 -0.12284851 310.05781555 C-0.12509518 306.34007077 -0.12107297 302.62235469 -0.11607273 298.90461355 C-0.11171341 294.83800394 -0.11316686 290.7713957 -0.11389065 286.70478439 C-0.11442284 278.80684569 -0.10980033 270.90891834 -0.10338932 263.01098256 C-0.09619699 253.87760053 -0.09539499 244.74422533 -0.09460449 235.61083984 C-0.08935145 211.49055809 -0.07539037 187.37027888 -0.0625 163.25 C-0.041875 109.3775 -0.02125 55.505 0 0 Z M53.88705444 124.94245911 C51.16796234 129.34812707 51.43978363 133.13525302 51.48242188 138.21875 C51.4754126 139.24532715 51.46840332 140.2719043 51.46118164 141.32958984 C51.44358916 144.72000243 51.45522943 148.10957905 51.46875 151.5 C51.46605546 153.8574235 51.46217336 156.21484593 51.45715332 158.57226562 C51.45125655 163.51182644 51.45982737 168.45109783 51.47851562 173.390625 C51.50130483 179.72276853 51.48818277 186.05423389 51.46422577 192.38635254 C51.4497729 197.25395824 51.45437153 202.12140313 51.46473694 206.98901367 C51.46740562 209.32381266 51.46412954 211.65862625 51.45481873 213.9934082 C51.44466202 217.25641569 51.46014323 220.51832437 51.48242188 223.78125 C51.47432495 224.74659668 51.46622803 225.71194336 51.45788574 226.70654297 C51.51174674 230.96387009 51.6088028 233.35881117 53.86517334 237.05709839 C58.9123149 241.65049216 64.77593763 241.26851673 71.203125 241.1171875 C72.51987213 241.09387863 72.51987213 241.09387863 73.86322021 241.07009888 C75.71573515 241.03340381 77.5681455 240.99104335 79.42041016 240.94335938 C82.22694394 240.87555701 85.03272819 240.839179 87.83984375 240.8046875 C101.97073585 240.53518047 112.21618873 238.45848493 122.6875 228.375 C129.72210741 220.777624 132.36211392 211.86897788 132.2109375 201.6796875 C131.28393101 189.90327177 124.60692923 181.51251604 117 173 C117.52400391 171.98679687 117.52400391 171.98679687 118.05859375 170.953125 C118.51363281 170.06109375 118.96867187 169.1690625 119.4375 168.25 C119.88996094 167.36828125 120.34242187 166.4865625 120.80859375 165.578125 C124.14678911 158.35448913 123.87943028 150.84672354 121.375 143.375 C117.71123526 134.32409685 112.56784337 128.68602264 104 124 C95.69112905 120.5102742 86.79062042 120.81363449 77.92919922 120.81469727 C75.87316561 120.81249804 73.8176587 120.7942592 71.76171875 120.77539062 C70.45589844 120.77345703 69.15007812 120.77152344 67.8046875 120.76953125 C66.61858887 120.76542236 65.43249023 120.76131348 64.21044922 120.75708008 C59.75182852 121.09444339 57.19515026 121.90128239 53.88705444 124.94245911 Z M154 126 C152.84250444 128.31499113 152.86707007 129.65392025 152.85282898 132.23103333 C152.84567368 133.11845718 152.83851837 134.00588104 152.83114624 134.92019653 C152.82845734 135.89632904 152.82576843 136.87246155 152.82299805 137.87817383 C152.81642685 138.9043129 152.80985565 139.93045197 152.80308533 140.98768616 C152.78332361 144.3941352 152.77168378 147.80054012 152.76171875 151.20703125 C152.75764322 152.36840796 152.7535677 153.52978466 152.74936867 154.7263546 C152.72849643 160.87233682 152.71419926 167.01829662 152.70483398 173.16430664 C152.69376259 179.5200008 152.65935718 185.87534552 152.61966228 192.23091602 C152.59354773 197.11135012 152.58514676 201.99170028 152.58155251 206.8721981 C152.5766738 209.21539357 152.56502355 211.55858498 152.54651451 213.90171242 C152.52223179 217.17930616 152.52306847 220.45598689 152.5300293 223.73364258 C152.51721924 224.70370239 152.50440918 225.67376221 152.49121094 226.67321777 C152.52459656 230.98059296 152.59649225 233.34757544 154.90437317 237.07914734 C161.64611829 243.25863448 174.50173077 241.18529427 183 241 C183.76070801 240.98743164 184.52141602 240.97486328 185.30517578 240.96191406 C187.72551347 240.91400594 190.14323679 240.83591134 192.5625 240.75 C193.32433594 240.73598145 194.08617187 240.72196289 194.87109375 240.70751953 C199.81467377 240.48650984 202.59004312 239.63248766 206 236 C207.11500247 232.167179 207.38251709 229.99004424 205.9375 226.25 C202.82430701 222.63467911 199.88973778 221.15425787 195.07495117 220.76123047 C191.5869811 220.70477189 188.11261188 220.73881806 184.625 220.8125 C183.41199219 220.82603516 182.19898438 220.83957031 180.94921875 220.85351562 C177.96568794 220.88875418 174.98307542 220.93802475 172 221 C172.00666183 219.85852005 172.01332367 218.7170401 172.02018738 217.54096985 C172.08099516 206.78505572 172.12597109 196.02917646 172.15543652 185.27312946 C172.17109422 179.74329274 172.19233462 174.21359476 172.22631836 168.68383789 C172.25890775 163.34758833 172.27685223 158.01147224 172.28463173 152.67513084 C172.29017597 150.63895758 172.30100244 148.60279165 172.31719017 146.56667519 C172.33895867 143.71526919 172.34196714 140.86441514 172.34057617 138.01293945 C172.351362 137.17064789 172.36214783 136.32835632 172.3732605 135.46054077 C172.34874212 130.81740699 172.03479746 127.7551092 169 124 C163.30684255 120.2045617 158.69454619 121.30545381 154 126 Z M224.3203125 139.58984375 C212.78987558 151.5667454 207.60619621 166.51630772 207.69946289 182.91601562 C208.14047747 199.82882577 215.9958606 214.3705907 227.9375 226.0625 C239.82561179 236.25522815 255.75855795 241.76864869 271.359375 240.7890625 C283.49242599 239.36005872 294.30680728 235.49606904 304 228 C304.68707031 227.47664063 305.37414062 226.95328125 306.08203125 226.4140625 C317.73439384 216.92284555 324.66163651 202.70087435 327 188 C328.41263582 170.9129119 323.25939638 155.60234576 313 142 C301.6688325 129.19085413 286.15752282 122.2090381 269.2109375 121.03515625 C251.93542236 120.84600827 236.74835298 127.92151107 224.3203125 139.58984375 Z M364.3203125 139.58984375 C352.78987558 151.5667454 347.60619621 166.51630772 347.69946289 182.91601562 C348.14932522 200.16813496 356.31084187 214.7311739 368.5 226.625 C372.32942722 229.82378742 376.5723952 232.06305681 381 234.3125 C381.66451172 234.65039551 382.32902344 234.98829102 383.01367188 235.33642578 C396.34277266 241.80765834 410.53981111 242.13595427 424.7265625 238.25390625 C438.28283147 233.41238162 448.01365229 223.45576389 454.3125 210.75 C458.68572998 200.60934955 461.55734041 189.09172446 460 178 C457.71488065 173.7682975 455.47698484 172.45158077 451 171 C446.73235151 170.63489699 442.47215543 170.67054551 438.18994141 170.68432617 C436.13780285 170.68748032 434.08711635 170.66401991 432.03515625 170.63867188 C422.57887516 170.55826576 422.57887516 170.55826576 414 174 C411.54678356 176.83653151 411 178.25123496 411 182 C412.26016841 185.78050523 413.92742854 187.49906974 417 190 C419.88667923 190.96634169 422.51642846 191.11813224 425.546875 191.09765625 C426.39121094 191.09443359 427.23554688 191.09121094 428.10546875 191.08789062 C428.97816406 191.07951172 429.85085938 191.07113281 430.75 191.0625 C431.63816406 191.05798828 432.52632813 191.05347656 433.44140625 191.04882812 C435.62767329 191.037074 437.81380179 191.02064249 440 191 C436.92523304 201.30648143 433.56905344 211.06963599 424 217 C418.44109233 219.65929995 413.38006337 220.55110599 407.25 220.5 C406.4672168 220.49572998 405.68443359 220.49145996 404.87792969 220.48706055 C394.96085597 220.19891559 387.24387565 216.67199073 380 210 C379.34 210 378.68 210 378 210 C377.72027344 209.41476562 377.44054687 208.82953125 377.15234375 208.2265625 C376.07740041 206.14955333 374.87967676 204.30357656 373.5625 202.375 C367.55252632 192.70214295 366.3502059 181.82953132 368.69140625 170.71875 C370.46963763 164.82603346 372.83324877 160.21049526 376.828125 155.5234375 C378.20323692 154.05612832 378.20323692 154.05612832 378 152 C378.58265625 151.72027344 379.1653125 151.44054687 379.765625 151.15234375 C382.51997574 149.73183069 385.03730914 148.04012265 387.609375 146.31640625 C394.07373641 142.7567824 399.88861534 141.44455547 407.25 141.5 C408.49245483 141.50314209 408.49245483 141.50314209 409.76000977 141.50634766 C417.85373613 141.71264752 424.08886113 144.256347 431.09765625 148.171875 C434.27284184 149.55409132 436.72139146 148.81965214 440 148 C443.15673772 145.84012682 443.89153038 144.31938276 445.125 140.6875 C444.97648215 136.3062234 444.18245217 134.79382889 441.203125 131.703125 C417.56327333 113.42834605 384.73479502 120.42326847 364.3203125 139.58984375 Z "
                  transform="translate(0,150)"
                />
                <path
                  d="M0 0 C0.74698179 -0.00265183 1.49396358 -0.00530365 2.26358119 -0.00803584 C4.78067094 -0.0157295 7.29771192 -0.01628804 9.81481266 -0.01688576 C11.63216259 -0.02090035 13.44951163 -0.02533857 15.26685959 -0.03016531 C20.27221919 -0.04213726 25.27756915 -0.04778072 30.28294027 -0.05234647 C35.6771768 -0.05830028 41.07140178 -0.06991075 46.46563053 -0.08063698 C59.4993609 -0.10516713 72.5330951 -0.11978959 85.56684145 -0.13269705 C89.24805315 -0.13640871 92.92926446 -0.14038197 96.61047578 -0.14444971 C119.46869421 -0.16968734 142.32691323 -0.19174121 165.18514252 -0.20417786 C170.48064965 -0.20710757 175.77615677 -0.21006923 181.07166386 -0.21308327 C182.38784354 -0.21382932 183.70402323 -0.21457537 185.06008715 -0.21534403 C206.37770006 -0.22799552 227.69521259 -0.26121535 249.01278996 -0.3028851 C270.89793009 -0.34531362 292.78302751 -0.36887401 314.66820866 -0.37409842 C326.95633484 -0.37751162 339.24433065 -0.38925614 351.53241634 -0.42220116 C361.99859391 -0.45021543 372.46461439 -0.4611949 382.93082654 -0.4500057 C388.26916785 -0.44482253 393.60718024 -0.44768392 398.94547367 -0.47247124 C403.83808051 -0.494999 408.73012283 -0.49419628 413.6227398 -0.47526737 C415.387316 -0.47247231 417.15193077 -0.47803823 418.91644507 -0.4930803 C434.69485853 -0.61930104 446.57050812 2.60746298 458.31311893 13.71904564 C483.17268042 40.05224093 469.64124393 96.87048296 469.64124393 120.13701439 C300.68124393 120.13701439 131.72124393 120.13701439 -42.35875607 120.13701439 C-42.35875607 25.81849587 -42.35875607 25.81849587 -28.77672482 11.46513939 C-20.77416084 3.91040746 -10.84652891 -0.0186959 0 0 Z M21.64124393 51.13701439 C18.92048348 55.60478945 18.99029879 60.0499986 19.64124393 65.13701439 C21.83468204 69.60512904 24.1282953 72.04564795 28.64124393 74.13701439 C33.52896414 75.48277292 38.48674112 75.32083247 43.51624393 75.32451439 C44.38893925 75.33676048 45.26163456 75.34900658 46.16077518 75.36162376 C52.74991557 75.37648649 58.28076381 75.18276383 63.45374393 70.69951439 C67.39203257 66.08609056 68.08670274 63.54683026 67.95765018 57.64482689 C67.49082376 53.94479526 66.11560813 51.87887742 63.64124393 49.13701439 C57.55796608 44.61355137 51.0400012 44.95483925 43.76624393 44.94951439 C42.89354862 44.9372683 42.02085331 44.9250222 41.12171268 44.91240501 C33.50425746 44.89522278 27.35480708 45.58669591 21.64124393 51.13701439 Z M101.64124393 51.13701439 C98.92048348 55.60478945 98.99029879 60.0499986 99.64124393 65.13701439 C101.83468204 69.60512904 104.1282953 72.04564795 108.64124393 74.13701439 C113.52896414 75.48277292 118.48674112 75.32083247 123.51624393 75.32451439 C124.38893925 75.33676048 125.26163456 75.34900658 126.16077518 75.36162376 C132.74991557 75.37648649 138.28076381 75.18276383 143.45374393 70.69951439 C147.39203257 66.08609056 148.08670274 63.54683026 147.95765018 57.64482689 C147.49082376 53.94479526 146.11560813 51.87887742 143.64124393 49.13701439 C137.55796608 44.61355137 131.0400012 44.95483925 123.76624393 44.94951439 C122.89354862 44.9372683 122.02085331 44.9250222 121.12171268 44.91240501 C113.50425746 44.89522278 107.35480708 45.58669591 101.64124393 51.13701439 Z M181.64124393 51.13701439 C178.92048348 55.60478945 178.99029879 60.0499986 179.64124393 65.13701439 C181.83468204 69.60512904 184.1282953 72.04564795 188.64124393 74.13701439 C193.52896414 75.48277292 198.48674112 75.32083247 203.51624393 75.32451439 C204.38893925 75.33676048 205.26163456 75.34900658 206.16077518 75.36162376 C212.74991557 75.37648649 218.28076381 75.18276383 223.45374393 70.69951439 C227.39203257 66.08609056 228.08670274 63.54683026 227.95765018 57.64482689 C227.49082376 53.94479526 226.11560813 51.87887742 223.64124393 49.13701439 C217.55796608 44.61355137 211.0400012 44.95483925 203.76624393 44.94951439 C202.89354862 44.9372683 202.02085331 44.9250222 201.12171268 44.91240501 C193.50425746 44.89522278 187.35480708 45.58669591 181.64124393 51.13701439 Z "
                  transform="translate(42.35875606536865,-0.13701438903808594)"
                />
                <path
                  d="M0 0 C10.5190688 6.66570239 18.32489188 15.53950455 21.171875 27.796875 C23.00368771 38.95427967 21.59305202 50.54258037 14.95703125 59.98828125 C13.88987203 61.24971136 12.78320867 62.47851417 11.64453125 63.67578125 C10.99613281 64.36414063 10.34773438 65.0525 9.6796875 65.76171875 C0.59610643 74.59890974 -8.92150341 77.42374811 -21.34057617 77.27001953 C-28.4207188 76.9513175 -34.20945747 75.28488756 -40.35546875 71.67578125 C-41.10054687 71.24136719 -41.845625 70.80695313 -42.61328125 70.359375 C-51.80678488 64.22454653 -57.16042599 54.32628457 -59.35546875 43.67578125 C-60.75044988 30.96275734 -57.98816323 20.07389763 -50.2578125 9.859375 C-47.28425221 6.44619184 -44.26305095 3.95407745 -40.35546875 1.67578125 C-39.52789062 1.18980469 -38.7003125 0.70382812 -37.84765625 0.203125 C-26.44214948 -5.49962838 -11.46746644 -5.69363718 0 0 Z "
                  transform="translate(286.35546875,294.32421875)"
                />
                <path
                  d="M0 0 C4.805625 -0.0825 9.61125 -0.165 14.5625 -0.25 C16.06498291 -0.28641602 17.56746582 -0.32283203 19.11547852 -0.36035156 C31.49492908 -0.46335444 31.49492908 -0.46335444 37 4 C40.74068657 8.82351689 42.37203296 12.64670056 42.28125 18.80859375 C41.6163771 23.9890618 39.16627073 27.89062053 35.4375 31.4375 C31.25845141 34.1163773 28.01396809 34.1182024 23.14453125 34.09765625 C21.93385986 34.09515869 20.72318848 34.09266113 19.47583008 34.09008789 C17.93693115 34.08098389 16.39803223 34.07187988 14.8125 34.0625 C9.924375 34.041875 5.03625 34.02125 0 34 C0 22.78 0 11.56 0 0 Z "
                  transform="translate(71,337)"
                />
                <path
                  d="M0 0 C4.00125 -0.103125 8.0025 -0.20625 12.125 -0.3125 C13.37555176 -0.35802002 14.62610352 -0.40354004 15.91455078 -0.45043945 C25.10433187 -0.56518217 25.10433187 -0.56518217 28.71875 2.40625 C32.42707017 6.62255923 33.47123905 9.18354491 33.3203125 14.97265625 C32.66767261 19.10338921 30.21563985 21.87919611 27.22558594 24.63598633 C24.39736221 26.36934372 22.44469311 26.4274313 19.140625 26.51171875 C18.13547852 26.54483154 17.13033203 26.57794434 16.09472656 26.61206055 C14.19158691 26.64940308 14.19158691 26.64940308 12.25 26.6875 C8.2075 26.790625 4.165 26.89375 0 27 C0 18.09 0 9.18 0 0 Z "
                  transform="translate(71,291)"
                /></svg
            ></a>
            <a href="https://github.com/Geo-sudo/" target="_blank"
              ><svg
                class="color"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 496 512"
              >
                <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path
                  d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                /></svg
            ></a>

            <a href="javascript:void(0)" @click="copyEmail">
              <svg
                class="color"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
                />
              </svg>
            </a>
            <div
              v-if="showConfirmation"
              :class="{ 'confirmation-message': true, 'fade-out': isFadingOut }"
            >
              Email copied to clipboard!
            </div>
          </div>
        </footer>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactView",
  props: ["themeColor"],
  data() {
    return {
      sentMessage: false,
      showConfirmation: false,
      isFadingOut: false,
      name: "",
      email: "",
      subject: "",
      message: "",
    };
  },
  methods: {
    showSentMessage() {
      this.sentMessage = true;
    },
    async submitForm() {
      // Validation: Check if fields are empty
      if (!this.name || !this.email || !this.subject || !this.message) {
        return alert("Please fill in all fields");
      }

      const WEB3FORMS_ACCESS_KEY = "837bf8f1-5b44-4405-9f54-fc8f03a60d0a";

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message,
        }),
      });

      const result = await response.json();

      if (result.success) {
        this.showSentMessage();
        // Reset form fields
        this.name = "";
        this.email = "";
        this.subject = "";
        this.message = "";
      } else {
        alert("An error occurred. Please try again later.");
      }
    },
    copyEmail() {
      const email = "george.nady.contact@gmail.com";
      navigator.clipboard
        .writeText(email)
        .then(() => {
          this.showConfirmation = true;
          this.isFadingOut = false;

          setTimeout(() => {
            this.isFadingOut = true;
          }, 2000);

          // Completely hide after fade-out
          setTimeout(() => {
            this.showConfirmation = false;
          }, 3000); // 1000ms for fade-out duration
        })
        .catch((err) => {
          console.error("Failed to copy email: ", err);
        });
    },
  },
  mounted() {
    Array.from(document.getElementsByClassName("color")).forEach((element) => {
      element.classList.add(this.themeColor);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.page-container {
  position: relative;
  min-height: 88vh;
  .content-wrap {
    padding-bottom: 100px;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    h1 {
      margin-left: auto;
      margin-right: auto;
    }
  }
  footer {
    position: absolute;
    bottom: 0;
    margin-left: auto;
    margin-right: auto;
    height: fit-content;
    width: 100%;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        text-decoration: none;
        transition: 0.3s;
        margin-left: 0.75rem;
        margin-right: 0.75rem;
        svg {
          @include generateColorsDarken("fill", 7);
          width: 25px;
          transition: 0.3s;
          &:hover {
            @include generateColors("fill");
          }
        }
      }
    }
  }
}

.main-container {
  margin-top: 1.5rem;
  // padding-left: 1.5rem;
  & > p.smspecial {
    font-size: 1.1rem;
    font-style: italic;
  }
  & > p:not(.smspecial) {
    font-size: 0.9rem;
  }
  .form-container {
    margin-top: 3rem;
    width: 100%;
    max-width: 900px;
    form {
      .row {
        width: 100%;
      }
      input,
      textarea {
        width: 100%;
        background-color: darken($color: $main-bg-color, $amount: 2);
        border: 1px solid;
        @include generateColorsDarken("border-color", 20);
        color: white;
        margin-bottom: 1rem;
        padding: 0.5rem 0.75rem;
        transition: 0.2s;
        &:last-child {
          margin-bottom: 0;
        }
        &:focus,
        &:focus-visible {
          @include generateColors("border-color");
          outline: none;
        }
      }
      input {
        height: 50px;
      }
      textarea {
        height: 100%;
        min-height: 175px;
        max-height: 250px;
        resize: vertical;
        margin: 0;
      }
      input[type="submit"] {
        margin-top: 1rem;
        &:hover {
          border: 3px solid;
          border-color: $main-bg-color;
          @include generateColorsDarken("background-color", 10);
        }
      }
    }
  }
  .sentMessage {
    margin-top: 2rem;
    font-size: 1rem;
    width: 100%;
    text-align: center;
  }
}

@media (max-width: 991.98px) {
  .page-container {
    min-height: unset !important;
  }
  .main-container {
    .form-container {
      form {
        textarea {
          height: 100px;
          min-height: 100px;
        }
      }
    }
  }
}

.confirmation-message {
  position: fixed;
  bottom: 20px;
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border-radius: 15px;
  font-size: 14px;
  text-align: center;
  opacity: 1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: opacity 1s ease-in-out;
  z-index: 1000;
}

.confirmation-message.fade-out {
  opacity: 0;
}
</style>
